import React from "react";
import { styles, ids } from "./Pagination.styles";
import { Icon } from "../../Core/Icon/Icon";
import { Text } from "../../Core/Text/Text";
import { View, TouchableOpacity } from "react-native";
import { useResponsive } from "../../Hooks";
import { theme } from "../../theme";
const PageButtons = (props) => {
    const { currentPage, totalPages, color = "light" } = props;
    const firstDelta = currentPage - 5 < 0 ? Math.abs(currentPage - 5) : 1;
    const lastDelta = totalPages - currentPage - 4 < 0
        ? Math.abs(totalPages - currentPage - 4)
        : 1;
    const delta = lastDelta > 1 ? lastDelta : firstDelta;
    const left = currentPage - delta;
    const right = currentPage + delta + 1;
    const visiblePages = [];
    for (let i = 1; i <= totalPages; i++) {
        if (i == 1 || i == totalPages || (i >= left && i < right)) {
            visiblePages.push(i);
        }
    }
    return (React.createElement(React.Fragment, null, visiblePages.flatMap((currentPage, index) => {
        const previousPage = visiblePages[index - 1];
        const pages = [
            React.createElement(PageButton, { key: currentPage, ...props, pageNumber: currentPage }),
        ];
        if (previousPage) {
            if (currentPage - previousPage === 2) {
                pages.unshift(React.createElement(PageButton, { key: previousPage + 1, ...props, pageNumber: previousPage + 1 }));
            }
            else if (currentPage - previousPage !== 1) {
                pages.unshift(React.createElement(Text, { key: `ellipsis-${index}`, styles: styles.ellipsis, color: color }, "..."));
            }
        }
        return pages;
    })));
};
const PageButton = ({ pageNumber, currentPage, onPageChange, color = "light", }) => {
    const isSelected = currentPage === pageNumber;
    return (React.createElement(TouchableOpacity, { style: [styles.pageButton, isSelected && styles.pageButtonSelected], onPress: () => onPageChange(pageNumber) },
        React.createElement(Text, { color: isSelected ? (color === "light" ? "dark" : "light") : color }, pageNumber)));
};
export const Pagination = (props) => {
    const { screens } = useResponsive();
    const { totalPages, currentPage, onPageChange, color = "light" } = props;
    return (React.createElement(View, { style: styles.wrapper, dataSet: { media: ids.wrapper } },
        React.createElement(TouchableOpacity, { onPress: () => onPageChange(1), disabled: currentPage === 1, style: [
                {
                    marginRight: theme.spacing.xsmall,
                },
                styles.chevron,
            ], dataSet: { media: ids.chevron }, testID: "firstPage" },
            React.createElement(Icon.DoubleChevron, { color: currentPage === 1 ? "greyscale.lighter" : color, size: "small", style: {
                    transform: [{ rotate: "180deg" }],
                    marginRight: theme.spacing.xsmall2,
                } })),
        React.createElement(TouchableOpacity, { onPress: () => onPageChange(currentPage - 1), disabled: currentPage === 1, style: [
                {
                    marginRight: theme.spacing.xsmall,
                },
                styles.chevron,
            ], dataSet: { media: ids.chevron }, testID: "previousPage" },
            React.createElement(Icon.Chevron, { color: currentPage === 1 ? "greyscale.lighter" : color, size: "small", style: {
                    transform: [{ rotate: "180deg" }],
                } })),
        screens.small && React.createElement(PageButtons, { ...props }),
        React.createElement(TouchableOpacity, { onPress: () => onPageChange(currentPage + 1), disabled: currentPage === totalPages, style: [
                {
                    marginLeft: theme.spacing.xsmall,
                },
                styles.chevron,
            ], dataSet: { media: ids.chevron }, testID: "nextPage" },
            React.createElement(Icon.Chevron, { color: currentPage === totalPages ? "greyscale.lighter" : color, size: "small" })),
        React.createElement(TouchableOpacity, { onPress: () => onPageChange(totalPages), disabled: currentPage === totalPages, style: [
                {
                    marginLeft: theme.spacing.xsmall,
                },
                styles.chevron,
            ], dataSet: { media: ids.chevron }, testID: "lastPage" },
            React.createElement(Icon.DoubleChevron, { color: currentPage === totalPages ? "greyscale.lighter" : color, size: "small" }))));
};
//# sourceMappingURL=Pagination.js.map